module.exports = __webpack_public_path__ + "img/feature_buy_en.bcab30f8.png";